<template>
  <span :class="{ underline: active }">
    {{ words[0] }}
  </span>
  <span :class="['inline-block', { underline: active }]">
    {{ words[1] }}
    <IconSprite
      id="chevron"
      role="presentation"
      class="text-[10px] ml-1.5 transition-[margin] group-hover:ml-2"
    />
  </span>
</template>

<script lang="ts" setup>
import IconSprite from '@/components/small/IconSprite.vue'
import { computed } from 'vue'

const { active, text } = defineProps<{
  active: boolean
  text: string
}>()

const words = computed(() => {
  const split = text.split(' ')
  const last = split.pop()
  return [split.join(' ') + ' ', last ?? '']
})
</script>
